<template>
  <div class="block-wrapper machine-learning">
    <a-row type="flex" :gutter="20">
      <a-col flex="12">
        <a-row type="flex" align="middle" v-if="!categories || categoryName" :gutter="10">
          <a-col flex="1">Версия нейронной сети</a-col>
          <a-col flex="2">
            <input-enum v-model="data.version" :options="versions"/>
          </a-col>
        </a-row>

        <a-row type="flex" align="middle" :gutter="10">
          <a-col flex="1">Кол-во эпох (обучающих циклов)</a-col>
          <a-col flex="2">
            <a-input-number v-model="data.epoch_number" size="large" @change="emitInput" />
          </a-col>
        </a-row>

        <div class="layers">
          <div class="header">
            <h2>Количество слоев</h2>
            <a-button
              type="primary" size="small" icon="plus"
              @click="addLayer"
            />
          </div>

          <template v-for="(_, index) in data.layers">
            <machine-learning-layer
              :key="index"
              v-model="data.layers[index].data"
              :number="index + 1"
              @change="emitInput"
              @remove="removeLayer(index)"
            />
          </template>
        </div>

        <div class="form">
          <a-row type="flex" align="middle" :gutter="10">
            <a-col flex="1">Отношение обучающей выборки к тестовой</a-col>
            <a-col flex="2">
              <a-input-number
                v-model="data.learning_to_test_relation"
                size="large"
                @change="emitInput"
              />
            </a-col>
          </a-row>

          <a-row type="flex" align="middle" :gutter="10">
            <a-col flex="1">Размер пакета</a-col>
            <a-col flex="2">
              <a-input-number v-model="data.package_size" size="large" @change="emitInput" />
            </a-col>
          </a-row>

          <a-row type="flex" align="middle" :gutter="10">
            <a-col flex="1">Уровень качества обучения</a-col>
            <a-col flex="2">
              <a-input-number v-model="data.quality" size="large" @change="emitInput" />
            </a-col>
          </a-row>

          <a-row type="flex" align="middle" :gutter="10">
            <a-col flex="1">Период дообучения нейронной сети (число размеченных позиций)</a-col>
            <a-col flex="2">
              <a-input-number
                v-model="data.further_learning_period"
                size="large"
                @change="emitInput"
              />
            </a-col>
          </a-row>

          <a-row type="flex" align="middle" :gutter="10">
            <a-col flex="1">Параметры расчета ошибки обучения (функция потерь)</a-col>
            <a-col flex="2">
              <a-input-number v-model="data.error_calculation" size="large" @change="emitInput" />
            </a-col>
          </a-row>

          <a-row type="flex" align="middle" :gutter="10">
            <a-col flex="1">Скорость обучения</a-col>
            <a-col flex="2">
              <a-input-number v-model="data.learning_rate" size="large" @change="emitInput" />
            </a-col>
          </a-row>

          <a-row type="flex" align="middle" :gutter="10">
            <a-col flex="1">Гиперпараметр регуляризации</a-col>
            <a-col flex="2">
              <a-input-number v-model="data.hyperparameter" size="large" @change="emitInput" />
            </a-col>
          </a-row>
        </div>
      </a-col>

      <a-col flex="10">
        <div v-if="data.category!==undefined" class="upload">
          <input-enum
            v-if="categories && !categoryName"
            v-model="data.category"
            :options="categories"
            @change="get_ML_history"
            @search="categorySearch"
          />
          <a-upload-dragger
            name="file"
            :customRequest="beforeUpload"
            :showUploadList="false"
          >
            <a-row
              type="flex" justify="center" align="middle"
              :gutter="10"
            >
              <a-col class="icon">
                <a-icon type="paper-clip" />
              </a-col>
              <a-col class="text">Загрузить<br />датасет</a-col>
            </a-row>
          </a-upload-dragger>
          <div>
            <h1>Ранее загруженные датасеты</h1>
            <a-table
              :class="['table', 'datasets']"
              :columns="dataSetColumns"
              :data-source="dataSets"
              :pagination="false"
            >
              <template slot="actions" slot-scope="record">
                <a-space>
                  <a-button
                    type="primary" shape="circle" icon="download"
                    @click="downloadDataset(record['Название файла'])"
                  />
                  <a-popconfirm
                    okText="Удалить"
                    cancelText="Отмена"
                    title="Подтвердите удаление"
                  >
                    <a-button type="primary" shape="circle" icon="delete" />
                  </a-popconfirm>
                </a-space>
              </template>
            </a-table>
          </div>
        </div>
        <div v-else>
          Сохраните изменения для загрузки датасета.
        </div>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import axios from "axios";
import MachineLearningLayer from './MachineLearningLayer';
import InputEnum from '../base/InputEnum';
import {apolloClient} from "@/apolloClient";
import TABLE_QUERY from "@/queries/table";
import store from "@/store";
import {storage} from "@/helpers";

const apiUrl = process.env.VUE_APP_ROSSTAT_API_URL;
const esUrl = process.env.VUE_APP_ELASTIC_URL;

const dataSetColumns = Object.freeze([
  {
    title: 'Название файла',
    dataIndex: 'Название файла',
    key: 'Название файла',
  },
  {
    title: 'Пользователь',
    dataIndex: 'Пользователь',
    key: 'Пользователь',
  },
  {
    // title: 'Скачать',
    scopedSlots: {
      customRender: 'actions',
    },
  },
]);



export default {
  name: 'MachineLearningConfig',
  components: { InputEnum, MachineLearningLayer },

  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    categoryName: {
      type: String,
      default: '',
    },
  },

  data: () => ({
    dataSetColumns,
    dataSets: null,
    categories: [],
    category_search: '',
    versions: [],
    data: {
      epoch_number: 0,
      layers: [],
      learning_to_test_relation: 0,
      package_size: 0,
      quality: 0,
      further_learning_period: 0,
      error_calculation: 0,
      learning_rate: 0,
      hyperparameter: 0,
      category: '',
      version: '',
    },
  }),

  watch: {
    value() {
      this.initData();
    },
    "data.version"() {
      this.value.version = this.data.version
    },
    category() {
      this.initData();
    }
  },

  mounted() {
    this.get_categories()
    this.get_versions()
    this.initData();
  },

  methods: {
    async downloadDataset(filename) {
      await axios
        .get(`${apiUrl}/download/get_dataset_link?filename=${filename}`,{
            // headers: {
            //   'finch-auth': `Bearer ${storage.get('authToken')}`
            // }
          })
        .then(({data}) => {
          if (data.status === 0) {
            this.$notification.error({
              message: `Произошла ошибка, файл не найден. Обратитесь к администратору.`,
            });
          }
          else {
            this.$notification.success({
              message: `Скачиваем файл...`,
            });
            window.location.href = data.fileUrl;
          }
        })
        .catch((error) => {
          console.log(error)
          this.$notification.error({
            message: `Произошла ошибка. Обратитесь к администратору.`,
          });
        })
    },
    initData() {
      this.data = {
        ...this.data,
        ...this.value,
      };
    },
    async get_ML_history(){
      const index = 'history_datatset_upload'
      const query = {
        size: 10000,
        from: 0,
        query: {
          bool: {
            must: [
              {
                "term": {
                  "Категория.keyword": this.data.category
                }
              }
            ],
          },
        },
      };
      this.dataRequest = axios.CancelToken.source();
      await axios
        .post(`${esUrl}/${index}/_search`, query, {
          cancelToken: this.dataRequest.token,
        })
        .then(({data}) => {
          this.dataSets = data.hits.hits.map((el)=>el._source)
        })
        .catch(() => {})
    },
    categorySearch(value) {
      this.category_search = value
      this.get_categories()
    },
    async get_categories() {
      if (!this.categoryName) {
        const prevCategory = this.category;
        const client = apolloClient
          .query({
            ...TABLE_QUERY,
            variables: {
              type: 'FNSClassesConfiguration',
              page: 0,
              pageSize: 999,
              filters: [
                {
                  field: "name",
                  value: this.category_search,
                  operator: "ILIKE"
                }
              ]
            },
          })
          .catch((error) => {
            this.$notification.error({
              message: `Ошибка получения таблицы категорий. Обратитесь к администратору.`,
            });
            throw error;
          });
        client.then((res) => {
          const arr = [];
          res.data.table.documents.forEach(({data}) => {
            arr.push(data.name)
          });
          const favorites = ['Картофель', "Морковь", 'Сметана', 'Соки фруктовые']
          this.categories = favorites.concat(arr.sort().filter(el => !(favorites.includes(el))));
          if (!this.categories.includes(prevCategory) && (prevCategory !== undefined)) {
            this.data.category = this.categories[0];
          }
        });
        this.category_search = ''
      }
      else {
        this.get_ML_history()
      }
    },
    async beforeUpload({file}) {
      const category = this.data.category || this.categoryName
      if (!category) {
        this.$notification.error({
          message: `Выберите категорию для загрузки датасета`,
        });
      }
      else {
        await axios
          .post(`${apiUrl}/upload/upload_dataset?filename=${file.name}`,
            {filename: file.name},
            // {
            //   headers: {
            //     'finch-auth': `Bearer ${storage.get('authToken')}`
            //   }
            // }
          )
          .then((res) => {
            res = res.data
            const formData = new FormData();
            for (const [key, value] of Object.entries(res.url.fields)) {
              formData.append(key, value);
            }
            formData.append('file', file, file.name);
            formData.append('ACL', "public-read")
            formData.append('Content-Type', 'multipart/form-data')
            axios
              .post('/s3/rosstat-storage', formData)
              .then(() => {
                axios
                  .post(
                    `${apiUrl}/dataset/index_dataset?filename=${res.filename}&category=${category}&username=${store.state.user.username}`,
                    {
                      headers: {
                        'finch-auth': `Bearer ${storage.get('authToken')}`,
                        'fio': encodeURIComponent(store.state.userFio),
                        'region': encodeURIComponent(store.state.regionName)
                      }
                    }
                  )
                  .then(()=> {
                    this.$notification.success({
                      message: `Датасет для категории ${this.data.category} успешно загружен`,
                    });
                  })
                  .catch((error)=> {
                    console.log(error)
                    this.$notification.error({
                      message: 'Произошла ошибка',
                    });
                  })
              })
              .catch((err) => {
                console.log(err)
                this.$notification.error({
                  message: 'Произошла ошибка',
                });
              });
          })
          .catch((err)=>{
            console.log(err)
            this.$notification.error({
              message: 'Произошла ошибка',
            });
          })
      }
      return false
    },
    async get_versions() {
      await this.axios
        .get(`${apiUrl}/worker/ml_version?category_name=${this.value.category}`, {
            // headers: {
            //   'finch-auth': `Bearer ${storage.get('authToken')}`
            // }
          })
        .then(({data}) => {
          this.versions = data.map(Number).sort(function (a, b) {
            return a - b;
          }).map(String);
        })
        .catch((error)=>{
          this.$notification.error({
            message: `Не удалось получить список версий. Обратитесь к администратору.`,
          });
          throw error
        })
    },

    addLayer() {
      this.data.layers.push({
        type: 'FNSMachineLearningLayerConfig',
        data: {},
      });

      this.emitInput();
    },

    removeLayer(index) {
      this.data.layers.splice(index, 1);
      this.emitInput();
    },

    emitInput() {
      this.$emit('input', this.data);
    },
  },
};
</script>

<style lang="scss">
.machine-learning {
  $secondary-font-color: #366dbb;

  .form {
    line-height: 17px;

    & > * {
      height: 60px;
    }
  }

  .add-button {
    width: 20px;
    height: 20px;
    padding: 0;
  }

  .layers {
    margin: 30px 0 30px;

    .header {
      margin-bottom: 10px;

      & > * {
        display: inline-block;
      }

      button {
        margin-left: 25px;
      }
    }

    .machine-learning-layer {
      color: $secondary-font-color;

      .ant-input-number {
        border-color: $secondary-font-color;
        color: $secondary-font-color;
      }

      .ant-select {
        .ant-select-selection {
          border-color: $secondary-font-color;
        }

        .ant-select-selection-selected-value {
          color: $secondary-font-color;
        }
      }
    }
  }

  .upload {
    .ant-upload-drag {
      height: 219px;
      background: transparent;
      border: 2px dashed #e1eaf5;
      box-sizing: border-box;
      border-radius: 6px;

      .icon,
      .text {
        color: $secondary-font-color;
      }

      .icon {
        font-size: 32px;
      }

      .text {
        font-size: 16px;
        text-align: left;
        font-weight: 500;
        line-height: 19px;
      }
    }

    .datasets {
      margin-top: 20px;

      .ant-btn-circle {
        border-width: 0;
        border-radius: 50%;
        background: #e4eaf4;

        .anticon {
          color: #243041 !important;
          font-size: 16px;
        }
      }
    }
  }
}
</style>
